import { MobileAppHeader } from "./appHeader/MobileAppHeader";
import { DesktopAppHeader } from "./appHeader/DesktopAppHeader";
import useResponsiveLayout from "./CustomHooks/useResponsiveLayout";



export function AppHeader() {
    const isMobile = useResponsiveLayout();

    return (

        <header className="bg-white shadow-md sticky top-0">
            {!isMobile ? (
                <DesktopAppHeader />
            ) : (
                <div className="flex justify-between items-center p-4" >
                    <MobileAppHeader />
                </div>
            )}
        </header>

    );
}
